module.exports = __webpack_public_path__ + "img/c02_buildingstartechhyraulicmining_Normal_ua.e5e3aac3.webp";